export default __webpack_public_path__ + "static/media/filter.cd6a9c28.svg";